import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { formatDateTime } from '@platform/core/lib/format';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { Avatar } from '@platform/ui';
import { useAgo } from '../useAgo';
import type { ICommentBubbleProps } from './ICommentBubbleProps';
import { splitMentions } from './mentions';

/**
 * Коментар (прототип v4): аватар 30px і бульбашка радіус 12 (10px 12px); власний — тло --accent-soft і рамка з домішкою акценту; ім'я 600
 * і відносний час (точний — у підказці); текст зберігає переноси, «@Ім'я» учасників підсвічено.
 */
export function CommentBubble({ comment, mine, names }: ICommentBubbleProps) {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  const ago = useAgo();
  return (
    <div className="rtab-comment">
      <Avatar user={comment.author} size={30} />
      <div className={cx('rtab-comment__bubble', mine && 'is-mine')}>
        <div className="rtab-comment__meta">
          <strong>{comment.author.name}</strong>
          <span title={formatDateTime(comment.at, lang)}>{ago(comment.at)}</span>
          {comment.editedAt && <span>· {t('recordPage.comments.edited')}</span>}
        </div>
        <div className="rtab-comment__text">
          {splitMentions(comment.body, names).map((p, i) => (p.mention ? <span key={i} className="rtab-mention">{p.text}</span> : p.text))}
        </div>
      </div>
    </div>
  );
}
